/* eslint-disable no-debugger */
import {
  ONE_SHEETER_SUMMARY_REQUIRED_SECTIONS,
  REQUIRED_SECTIONS,
  getStandardizedLabels,
} from "../reports";
import { MetadataService } from "./metadata.service";
import { formatDateAsMMDDYYYY, getOutputType } from "./metadata.utils";
import { standardizeKey, standardizeObjectKeys } from "./standardizer.helper";

const getLabel = ({ standardizedLabels, originalLabel }) => {
  const standardizedLabel = standardizeKey(originalLabel);

  const override = standardizedLabels[standardizedLabel]?.override;
  if (Array.isArray(override)) return override.join(" ");

  return (
    override || standardizedLabels[standardizedLabel]?.label || originalLabel
  );
};

const overrideDataLabelsBySectionRecursive = ({ standardizedLabels, data }) => {
  if (!data || Array.isArray(data) || typeof data !== "object") return data;

  return Object.entries(data).reduce((acc, [originalLabel, originalValue]) => {
    const label = getLabel({ standardizedLabels, originalLabel });
    const standardizedValue = overrideDataLabelsBySectionRecursive({
      standardizedLabels,
      data: originalValue,
    });

    return { ...acc, [label]: standardizedValue };
  }, {});
};

const overrideDataLabelsBySection = ({ sectionMetadata, data }) => {
  const standardizedSectionKey = standardizeKey(sectionMetadata.sectionKey);
  const standardizedSectionKeyAlternative = standardizeKey(
    sectionMetadata.sectionKeyAlternative
  );
  const standardizedData = standardizeObjectKeys(data);
  const sectionData =
    standardizedData[standardizedSectionKey] ||
    standardizedData[standardizedSectionKeyAlternative];

  if (!sectionMetadata.labels || !sectionData) {
    return { ...sectionMetadata, data: sectionData };
  }

  const standardizedLabels = getStandardizedLabels({
    referenceLabels: sectionMetadata.labels,
  });

  const dataWithUpdatedLabels = overrideDataLabelsBySectionRecursive({
    standardizedLabels,
    data: sectionData,
  });
  return { ...sectionMetadata, data: dataWithUpdatedLabels };
};

const processSectionData = (data, customizationLabel) => {
  //debugger;
  const { reportType, assetType } = getOutputType(data);

  const sectionMetadata = MetadataService.getSectionByCustomizationLabel(
    reportType,
    assetType,
    customizationLabel
  );

  const updatedSectionMetadata = {
    ...sectionMetadata,
    reportDate: formatDateAsMMDDYYYY(data.Cover["Report Date"]),
  };

  return overrideDataLabelsBySection({
    sectionMetadata: updatedSectionMetadata,
    data,
  });
};

export const processAllDataFromSections = (data, sections) => {
  const { reportType, assetType } = getOutputType(data);

  const neededSections = new Set([
    ...sections,
    ...REQUIRED_SECTIONS,
    ...ONE_SHEETER_SUMMARY_REQUIRED_SECTIONS[reportType][assetType],
  ]);

  return Array.from(neededSections).reduce((acc, customizationLabel) => {
    const sectionMetadata = processSectionData(data, customizationLabel);
    if (acc.toLowerString === "cover") {
      return { [sectionMetadata.sectionMetadataKey]: sectionMetadata };
    }
    return { ...acc, [sectionMetadata.sectionMetadataKey]: sectionMetadata };
  });
};
